import { EntityRequestEntmt } from "../../entity/EntityRequestEntmt";

export class DtoRequestEntmtsDeleteRes extends EntityRequestEntmt {
  public message: string | null = null;
}
